export default () => ({
  expanded: null,
  init() {
    const elem = this.$refs.content;
    elem.style.display = 'none';
  },
  toggle() {
    const elem = this.$refs.content;

    if (this.expanded) {
      this.expanded = false;
      elem.style.display = 'block';
      elem.style.height = `${elem.scrollHeight}px`;
      setTimeout(() => {
        elem.style.height = '0px';
      }, 1);
      elem.addEventListener(
        'transitionend',
        (e) => {
          if (e.target === elem) {
            elem.style.height = '';
            elem.style.display = 'none';
          }
        },
        {
          once: true,
        }
      );
    } else {
      this.expanded = true;
      elem.style.display = 'block';
      elem.style.height = '0px';
      setTimeout(() => {
        elem.style.height = `${elem.scrollHeight}px`;
      }, 1);
      elem.addEventListener(
        'transitionend',
        (e) => {
          if (e.target === elem) {
            elem.style.display = '';
            elem.style.height = '';
          }
        },
        {
          once: true,
        }
      );
    }
  },
});